import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/skillMapDetail';

/**
 * スキルマップ詳細情報のState型
 */
export interface ISkillMapDetailState {
	readonly skillMapInfo: Actions.ISkillMapDetail;
}

/**
 * スキル詳細情報画面のState初期値
 */
const initState: ISkillMapDetailState = {
	skillMapInfo: {
		applyFlg: '', // 利用フラグ
		comment: '', // 備考
		compulsoryID: '', // 区分
		credit: 0, // 単位
		managementCode: '', // 管理番号
		materialFileList: [], // スキルマップ関連資料
		outline: '', // 概要
		purpose: '', // 目的
		skillMapId: '', // スキルマップID
		skillMapManager: '', // スキルマップ管理者
		skillMapName: '', // スキルマップ名
		subType: '', // サブ種別
		target: '', // 対象者
	},
};

const skillMapDetail = (state: ISkillMapDetailState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initState;
		state = initializeState(state);
	}

	// スキルマップ詳細情報設定
	if (isType(action, Actions.setSkillMapDetail)) {
		let newState: ISkillMapDetailState = {
			...state,
			...action.payload,
			skillMapInfo: {
				...state.skillMapInfo,
				...action.payload.skillMapInfo,
			},
		};

		if (action.payload.skillMapInfo.materialFileList) {
			newState = {
				...newState,
				skillMapInfo: {
					...newState.skillMapInfo,
					materialFileList: action.payload.skillMapInfo.materialFileList.slice(),
				},
			};
		}

		return newState;
	}

	return state;
};

export default skillMapDetail;



// WEBPACK FOOTER //
// ./src/reducers/skillMapDetail.ts